module.exports = __webpack_public_path__ + "img/mosaico-hero.15aab320.png";